module.exports = __webpack_public_path__ + "static/media/Nota disfruta la temporada invernal.285c1943.png";